import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'app/auth/service';


@Component({
  selector: 'app-modalCanalDenunciaApp',
  templateUrl: './modalCanalDenunciaApp.component.html',
  styleUrls: ['./modalCanalDenunciaApp.component.scss']
})
export class ModalCanalDenunciaAppComponent implements OnInit {
  @Input() dataToggle;

  constructor( private router: Router, private modal: NgbModal, public authService: AuthenticationService) { }

  ngOnInit() {
   this.modal.open;
  }
  canalDedenuncia() {
    this.router.navigateByUrl(`/portal/canal-de-denuncia`)
  }
 

}
